import React from 'react'
import styles from "./Modal.module.css"

const CustomModal = ({ show, children, maxsize, minsize }) => {
    if (!show) {
        return null
    }

    return (
        <div className={styles.modalbackdrop}>
            <div
                className={styles.modalcontent}
            >
                {children}
            </div>
        </div>
    )
}

export default CustomModal